/* Base translations · Opening balances and completeness — moved unchanged out of lib/i18n.js (STEP 6 · split 6f).
   Top-level keys owned by this file (no other base file and not i18n.js define them): ob, comp. */
export const I18N_BASE_OPENING_BALANCES = {
  en: {
    // Batch C · Round C1 · W7 — Opening Balances screen
    ob: {
      title: "Opening Balances",
      subtitle: "PY closing vs CY opening reconciliation, procedures and conclusion.",
      statusNotSet: "Not set — choose Initial or Continuing for this engagement first (Settings).",
      pyClosing: "PY closing (audited)",
      cyOpening: "CY opening",
      pyClosingFrom: "PY closing — from {source}",
      cyOpeningFrom: "CY opening — from {source}",
      srcPriorYearGl: "prior-year GL",
      srcPriorYearTb: "prior-year TB",
      srcManual: "manual entry",
      srcOpeningJournal: "GL opening journal {voucher}",
      plClosed: "Prior-year profit {amount} ({n} P&L accounts) carried to account {account} — included in its prior-year closing balance.",
      plClosedRow: "incl. prior-year profit",
      difference: "Difference (PY closing − CY opening)",
      explanation: "Explanation",
      restated: "Restated",
      restatedReason: "Restated reason",
      tickMark: "Tick-mark",
      manual: "Manual",
      manualReason: "Reason (required for manual entry)",
      account: "Account",
      action: "Action",
      fsHead: "FS head",
      totalsByHead: "Totals by FS head",
      noPriorYearTb: "No prior-year TB imported",
      noPriorYearReason: "Reason (required)",
      priorYearTbImport: "Prior-year TB import",
      openingJournal: "GL opening journal",
      openingJournalNone: "No identifiable opening journal in the GL — CY opening = manual per account.",
      openingJournalPresent: "Opening journal identified at {date}: {entries} entries · {accounts} accounts · Σdebits {debits} · Σcredits {credits} (balanced).",
      openingJournalIdentifiedBy: "Identified by: {reason}",
      openingJournalDateOnly: "GL entries dated prior year-end — to be confirmed",
      openingJournalVoucher: "voucher prefix {prefix}",
      openingJournalDateReason: "entries dated {date} (prior year-end)",
      suggestedNotConfirmed: "Suggested — not confirmed",
      suggestedTotal: "Suggested",
      pyClosingPh: "Amount",
      cyOpeningPh: "Amount",
      openingConfirmPrompt: "Use these as CY opening balances?",
      openingConfirmYes: "Yes — treat as CY opening",
      openingConfirmNo: "No — treat as prior-year closing / adjusting entries",
      openingConfirmedBy: "Confirmed by {name} on {date}",
      openingUnconfirmed: "Suggested (unconfirmed)",
      openingConfirmed: "Confirmed as CY opening",
      openingVoucherPrefixes: "Voucher prefixes in these entries",
      openingFirstVouchers: "Voucher numbers",
      openingVoucherCount: "{n} vouchers (first 10 shown)",
      sourceGlOpening: "Source: GL opening journal",
      sourceGlUnconfirmed: "Source: GL entries dated prior year-end (unconfirmed)",
      sourceManual: "Manual entry",
      sourcePyTb: "Prior-year TB import",
      openPriorYearTbImport: "Open prior-year TB import",
      pyClosingNotEntered: "Not entered",
      pyClosingEnter: "Enter PY closing manually",
      cyOpeningNotEntered: "Not entered",
      cyOpeningEnter: "Enter CY opening manually",
      diffNotComputed: "—",
      rowIncomplete: "Row incomplete (missing figure)",
      incompleteRows: "Incomplete rows (missing figures)",
      sourceGlOpening: "Source: GL opening journal",
      sourceManual: "Manual entry",
      sourcePyTb: "Prior-year TB import",
      sendToMisstatements: "Send to misstatements",
      procs: {
        title: "Initial-engagement procedures (ISA 510)",
        readPyFs: "PY financial statements and predecessor auditor's report read",
        predecessorWp: "Predecessor auditor's working papers reviewed",
        currentPeriod: "Current-period procedures provide evidence over opening balances",
        specific: "Specific procedures on opening balances performed",
        atLeastOne: "At least one of the three procedures above is required for an initial engagement.",
        policies: "Accounting policies applied consistently (or changes properly accounted for)",
        policyYes: "Yes",
        policyNo: "No",
        note: "Note / evidence link",
      },
      rollForward: {
        title: "Continuing engagement — roll-forward check",
        agrees: "Prior-year signed-off closing agrees to CY opening",
        agreesYes: "Yes",
        agreesNo: "No — investigate",
        note: "Roll-forward note",
        procHidden: "Not applicable for a continuing engagement — 213(a) stays in the file as N/A.",
      },
      conclusion: "Conclusion",
      preparer: "Preparer",
      reviewer: "Reviewer",
      markComplete: "Mark complete",
      unmark: "Unmark complete",
      completed: "Completed",
      compute: "Recompute (background)",
      computedInBackend: "Recomputed",
      blocksComplete: "Cannot mark complete:",
      reasons: {
        engagement_status_not_set: "Set Initial or Continuing on the engagement first.",
        unresolved_differences: "Explain every non-zero difference.",
        incomplete_rows: "Every row must have PY closing and CY opening entered (or a reason).",
        opening_journal_unconfirmed: "Confirm whether the prior year-end entries are the CY opening balances.",
        initial_procedures_required: "At least one initial procedure (predecessor WP / current-period / specific) is required.",
        read_py_fs_required: "Tick 'PY FS + predecessor report read'.",
        roll_forward_not_set: "Set the roll-forward answer (Yes / No).",
        accounting_policies_not_evaluated: "Evaluate accounting policies consistency.",
        conclusion_missing: "Conclusion is required.",
        preparer_missing: "Preparer sign-off is required.",
        reviewer_missing: "Reviewer sign-off is required.",
      },
    },
    // Batch C · Round C1 · W5 — Completeness worksheet
    comp: {
      voucherAmountDiffers: "Voucher found — amount differs",   // Batch 25 · C9
      matchSummaryDiffers: "{n} voucher found — amount differs · Total {total}",
      uploadOk: "File uploaded.",
      title: "Completeness worksheet",
      subtitle: "Trace source documents → GL for this head.",
      direction: "Source documents → GL",
      addWorksheet: "Add worksheet",
      nextFreeRef: "Next free ref",
      matchWindow: "Match window (days)",
      sourceFile: "Source-document listing",
      upload: "Upload listing \u2068(.xlsx / .csv)\u2069",
      uploadFirst: "Upload the source-document listing first.",
      sendToSampling: "Send population to Sampling",
      sentToSamplingOk: "Population sent to Sampling.",
      sampleReturned: "Sample drawn — returned from Sampling",
      runMatch: "Run GL match",
      matchQueued: "GL match started.",
      matching: "Matching…",
      matchSummary: "{matched} matched · Total {matchedTotal} · {unmatched} not found · Total {unmatchedTotal}",
      matchRunAt: "Run at {date}",
      matchedVoucher: "GL match",
      colDocNo: "Doc no.",
      colParty: "Party",
      recordedInPeriod: "Recorded in correct period?",
      amountAgrees: "Amount agrees?",
      remarks: "Remarks",
      supportUpload: "Support upload",
      suggested: "Suggested GL row(s)",
      confirm: "Confirm",
      confirmed: "Confirmed",
      notFound: "Not found in GL",
      sendToMisstatements: "Send to misstatements",
      sentToMsOk: "Sent to misstatements.",
      conclusion: "Conclusion",
      preparer: "Preparer",
      reviewer: "Reviewer",
      markComplete: "Mark complete",
      computedInBackend: "Recomputed",
      reasons: {
        no_rows: "The sample must be drawn from Sampling before Mark-complete.",
        no_listing: "Upload the source-document listing first.",
        row_decision_missing: "Every sampled row needs a Yes / No decision (period + amount).",
        conclusion_missing: "Conclusion is required.",
        preparer_missing: "Preparer sign-off is required.",
        reviewer_missing: "Reviewer sign-off is required.",
      },
    },
  },
  ar: {
    // Batch C · Round C1 · W7 — الأرصدة الافتتاحية
    ob: {
      title: "الأرصدة الافتتاحية",
      subtitle: "مطابقة إقفال السنة السابقة مع افتتاح السنة الحالية، الإجراءات والاستنتاج.",
      statusNotSet: "غير محدد — اختر «ارتباط أولي» أو «مستمر» لهذا الارتباط أولاً (الإعدادات).",
      pyClosing: "رصيد الإقفال للسنة السابقة (مُراجَع)",
      cyOpening: "الرصيد الافتتاحي للسنة الحالية",
      pyClosingFrom: "رصيد الإقفال للسنة السابقة — من {source}",
      cyOpeningFrom: "الرصيد الافتتاحي للسنة الحالية — من {source}",
      srcPriorYearGl: "دفتر الأستاذ للسنة السابقة",
      srcPriorYearTb: "ميزان المراجعة للسنة السابقة",
      srcManual: "إدخال يدوي",
      srcOpeningJournal: "القيد الافتتاحي في دفتر الأستاذ {voucher}",
      plClosed: "أُقفل ربح السنة السابقة {amount} ({n} حسابًا من قائمة الدخل) إلى {account} — مُدرج في رصيد إقفاله للسنة السابقة.",
      plClosedRow: "يشمل ربح السنة السابقة",
      difference: "الفرق (إقفال السنة السابقة − افتتاحي السنة الحالية)",
      explanation: "التفسير",
      restated: "مُعاد عرضه",
      restatedReason: "سبب إعادة العرض",
      tickMark: "علامة التدقيق",
      manual: "يدوي",
      manualReason: "السبب (مطلوب للإدخال اليدوي)",
      account: "الحساب",
      action: "الإجراء",
      fsHead: "بند القوائم المالية",
      totalsByHead: "الإجماليات حسب البند",
      noPriorYearTb: "لا يوجد ميزان مراجعة للسنة السابقة",
      noPriorYearReason: "السبب (مطلوب)",
      priorYearTbImport: "استيراد ميزان السنة السابقة",
      openingJournal: "قيد الأرصدة الافتتاحية في دفتر الأستاذ",
      openingJournalNone: "لا يوجد قيد افتتاحي يمكن تحديده في دفتر الأستاذ — الرصيد الافتتاحي يُدخل يدويًا لكل حساب.",
      openingJournalPresent: "تم تحديد قيد افتتاحي بتاريخ {date}: {entries} قيدًا · {accounts} حسابًا · إجمالي المدين {debits} · إجمالي الدائن {credits} (متزن).",
      openingJournalIdentifiedBy: "المصدر: {reason}",
      openingJournalDateOnly: "قيود دفتر الأستاذ بتاريخ نهاية السنة السابقة — بحاجة إلى تأكيد",
      openingJournalVoucher: "بادئة السند {prefix}",
      openingJournalDateReason: "قيود بتاريخ {date} (نهاية السنة السابقة)",
      suggestedNotConfirmed: "مقترح — لم يُؤكَّد",
      suggestedTotal: "المقترح",
      pyClosingPh: "المبلغ",
      cyOpeningPh: "المبلغ",
      openingConfirmPrompt: "هل تُستخدم كأرصدة افتتاحية للسنة الحالية؟",
      openingConfirmYes: "نعم — تُعامَل كافتتاح للسنة الحالية",
      openingConfirmNo: "لا — تُعامَل كإقفال / تعديلات للسنة السابقة",
      openingConfirmedBy: "تم التأكيد بواسطة {name} في {date}",
      openingUnconfirmed: "مقترح (غير مؤكد)",
      openingConfirmed: "تم التأكيد كافتتاح للسنة الحالية",
      openingVoucherPrefixes: "بادئات السندات في هذه القيود",
      openingFirstVouchers: "أرقام السندات",
      openingVoucherCount: "{n} سندًا (تُعرض أول 10)",
      sourceGlOpening: "المصدر: قيد الأستاذ الافتتاحي",
      sourceGlUnconfirmed: "المصدر: قيود بتاريخ نهاية السنة السابقة (غير مؤكدة)",
      sourceManual: "إدخال يدوي",
      sourcePyTb: "استيراد ميزان السنة السابقة",
      openPriorYearTbImport: "فتح استيراد ميزان السنة السابقة",
      pyClosingNotEntered: "لم يُدخَل",
      pyClosingEnter: "إدخال إقفال السنة السابقة يدويًا",
      cyOpeningNotEntered: "لم يُدخَل",
      cyOpeningEnter: "إدخال افتتاح السنة الحالية يدويًا",
      diffNotComputed: "—",
      rowIncomplete: "الصف غير مكتمل (رقم مفقود)",
      incompleteRows: "صفوف غير مكتملة (أرقام مفقودة)",
      sourceGlOpening: "المصدر: قيد الأستاذ الافتتاحي",
      sourceManual: "إدخال يدوي",
      sourcePyTb: "استيراد ميزان السنة السابقة",
      sendToMisstatements: "إرسال إلى التحريفات",
      procs: {
        title: "إجراءات الارتباط الأولي (ISA 510)",
        readPyFs: "تمت قراءة القوائم المالية للسنة السابقة وتقرير المراجع السابق",
        predecessorWp: "تمت مراجعة أوراق عمل المراجع السابق",
        currentPeriod: "إجراءات الفترة الحالية تقدم أدلة على الأرصدة الافتتاحية",
        specific: "تم تنفيذ إجراءات محددة على الأرصدة الافتتاحية",
        atLeastOne: "يُشترط تنفيذ إجراء واحد على الأقل من الإجراءات الثلاثة أعلاه.",
        policies: "السياسات المحاسبية طُبِّقت باستمرار (أو التغييرات جرى معالجتها بشكل مناسب)",
        policyYes: "نعم",
        policyNo: "لا",
        note: "ملاحظة / رابط الدليل",
      },
      rollForward: {
        title: "الارتباط المستمر — فحص المطابقة",
        agrees: "رصيد الإقفال للسنة السابقة الموقّع يتطابق مع افتتاح السنة الحالية",
        agreesYes: "نعم",
        agreesNo: "لا — يجب التحقق",
        note: "ملاحظة المطابقة",
        procHidden: "غير قابل للتطبيق (ارتباط مستمر — 213(a) يظهر «غير قابل للتطبيق»، ولم يُحذف).",
      },
      conclusion: "الاستنتاج",
      preparer: "المُعِد",
      reviewer: "المُراجِع",
      markComplete: "تعليم مكتمل",
      unmark: "إلغاء التعليم",
      completed: "مكتمل",
      compute: "إعادة الحساب (خلفي)",
      computedInBackend: "أُعيد الحساب",
      blocksComplete: "لا يمكن تعليمه مكتملًا:",
      reasons: {
        engagement_status_not_set: "اضبط «أولي» أو «مستمر» على الارتباط أولاً.",
        unresolved_differences: "قدِّم تفسيرًا لكل فرق غير صفري.",
        incomplete_rows: "يجب إدخال رصيد إقفال السنة السابقة وافتتاح السنة الحالية لكل صف (أو تقديم سبب).",
        opening_journal_unconfirmed: "أكِّد ما إذا كانت قيود نهاية السنة السابقة تمثل الأرصدة الافتتاحية للسنة الحالية.",
        initial_procedures_required: "مطلوب إجراء أولي واحد على الأقل (أوراق سابقة / إجراءات الفترة / إجراءات محددة).",
        read_py_fs_required: "ضع علامة على «تمت قراءة القوائم وتقرير المراجع السابق».",
        roll_forward_not_set: "اضبط إجابة المطابقة (نعم / لا).",
        accounting_policies_not_evaluated: "قيِّم استمرار السياسات المحاسبية.",
        conclusion_missing: "الاستنتاج مطلوب.",
        preparer_missing: "توقيع المُعِد مطلوب.",
        reviewer_missing: "توقيع المُراجِع مطلوب.",
      },
    },
    // Batch C · Round C1 · W5 — ورقة الاكتمال
    comp: {
      voucherAmountDiffers: "تم العثور على القيد — المبلغ مختلف",   // Batch 25 · C9
      matchSummaryDiffers: "{n} تم العثور على القيد — المبلغ مختلف · الإجمالي {total}",
      uploadOk: "تم رفع الملف.",
      title: "ورقة اختبار الاكتمال",
      subtitle: "تتبُّع المستندات المصدرية إلى دفتر الأستاذ لهذا البند.",
      direction: "المستندات المصدرية ← دفتر الأستاذ",
      addWorksheet: "إضافة ورقة عمل",
      nextFreeRef: "المرجع التالي المتاح",
      matchWindow: "نافذة المطابقة (أيام)",
      sourceFile: "قائمة المستندات المصدرية",
      upload: "رفع القائمة \u2068(.xlsx / .csv)\u2069",
      uploadFirst: "ارفع قائمة المستندات المصدرية أولاً.",
      sendToSampling: "إرسال المجتمع إلى العينات",
      sentToSamplingOk: "تم إرسال المجتمع إلى العينات.",
      sampleReturned: "تم سحب العينة — عادت من قسم العينات",
      runMatch: "تشغيل مطابقة الأستاذ",
      matchQueued: "بدأت مطابقة الأستاذ.",
      matching: "جاري المطابقة…",
      matchSummary: "{matched} مطابقة · الإجمالي {matchedTotal} · {unmatched} غير موجود · الإجمالي {unmatchedTotal}",
      matchRunAt: "شُغِّلت في {date}",
      matchedVoucher: "قيد الأستاذ المطابق",
      colDocNo: "رقم المستند",
      colParty: "الطرف",
      recordedInPeriod: "مُسجَّل في الفترة الصحيحة؟",
      amountAgrees: "المبلغ متطابق؟",
      remarks: "ملاحظات",
      supportUpload: "رفع مستند داعم",
      suggested: "قيود مقترحة من الأستاذ",
      confirm: "تأكيد",
      confirmed: "تم التأكيد",
      notFound: "غير موجود في دفتر الأستاذ",
      sendToMisstatements: "إرسال إلى التحريفات",
      sentToMsOk: "تم الإرسال إلى التحريفات.",
      conclusion: "الاستنتاج",
      preparer: "المُعِد",
      reviewer: "المُراجِع",
      markComplete: "تعليم مكتمل",
      computedInBackend: "أُعيد الحساب",
      reasons: {
        no_rows: "يجب سحب العينة من قسم العينات قبل التعليم بالإكمال.",
        no_listing: "ارفع قائمة المستندات المصدرية أولاً.",
        row_decision_missing: "كل صف بالعينة يحتاج قرار نعم/لا (الفترة والمبلغ).",
        conclusion_missing: "الاستنتاج مطلوب.",
        preparer_missing: "توقيع المُعِد مطلوب.",
        reviewer_missing: "توقيع المُراجِع مطلوب.",
      },
    },
  },
};

export default I18N_BASE_OPENING_BALANCES;
